import { render } from "./DetailPageBtn.vue?vue&type=template&id=d0f529ce&scoped=true"
import script from "./DetailPageBtn.vue?vue&type=script&lang=js"
export * from "./DetailPageBtn.vue?vue&type=script&lang=js"

import "./DetailPageBtn.vue?vue&type=style&index=0&id=d0f529ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f529ce"]])

export default __exports__